import classnames from 'classnames';
import React from 'react';

import './Spinner.scss';

interface Props {
  className?: string;
  percentage?: number;
  circumference?: number;
  stroke?: number;
  isSpinning?: boolean;
}

export const Spinner: React.FC<Props> = ({
  className,
  circumference = 24,
  stroke = 2,
  percentage = 50,
  isSpinning = true,
}) => {
  const progress = Math.max(0, Math.min(100, Math.floor(percentage)));

  const radius = circumference / 2;
  const strokeHalf = stroke / 2;

  // We subtract the stroke to make sure the component is fully rendered
  const mathRadius = radius - strokeHalf;
  const center = Math.PI * (mathRadius * 2);
  const strokeProgress = Math.max(0.5, progress);
  const strokeOffset = ((100 - strokeProgress) / 100) * center;
  const pathLength = Math.PI * 2 * mathRadius;

  return (
    <svg
      width={circumference}
      height={circumference}
      className={classnames(
        'Spinner',
        { 'Spinner--spinning': isSpinning },
        className
      )}
      shapeRendering="geometricPrecision"
      viewBox={`0 0 ${circumference} ${circumference}`}
    >
      <circle
        className="Spinner__track"
        r={radius - strokeHalf}
        cx={radius}
        cy={radius}
        fill="transparent"
        style={{
          strokeDasharray: pathLength,
          strokeWidth: stroke,
        }}
      />

      <circle
        className="Spinner__progress"
        r={radius - strokeHalf}
        cx={radius}
        cy={radius}
        fill="transparent"
        style={{
          strokeDasharray: pathLength,
          strokeDashoffset: strokeOffset,
          strokeWidth: stroke,
        }}
      />
    </svg>
  );
};
